// extracted by mini-css-extract-plugin
export default {"modal":"modal__ebAH7","modal__content":"modal__content__RrEV9","modal__buttons":"modal__buttons__b1jx5"};